var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center my-5"},[_c('b-img',{attrs:{"src":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }